import React from 'react';
import { Container, Typography, Paper } from '@mui/material';

const PrivacyPolicy: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
            <Paper elevation={0} sx={{ p: 4, borderRadius: 2 }}>
                <Typography variant="h3" gutterBottom fontWeight="bold" color="primary">Privacy Policy</Typography>
                <Typography variant="caption" display="block" gutterBottom>Last Updated: January 2026</Typography>

                <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>1. Introduction</Typography>
                <Typography variant="body1" paragraph>
                    We value your privacy. This policy explains how we collect and use your data.
                </Typography>

                <Typography variant="h6" gutterBottom>2. Data We Collect</Typography>
                <Typography variant="body1" paragraph>
                    We collect account information, learning progress data, and usage statistics to improve your experience.
                </Typography>

                <Typography variant="h6" gutterBottom>3. How We Use Your Data</Typography>
                <Typography variant="body1" paragraph>
                    Your data is used to personalize your dashboard, track your academic progress, and provide insights. We do not sell your data to third parties.
                </Typography>
            </Paper>
        </Container>
    );
};
export default PrivacyPolicy;
